module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaDerecha-ap-cc07d613.png";